export const TEXTS = {
  REQUEST_REPORT_MODAL_TITLE: 'Отчет по рекламным кампаниям',
  REQUEST_REPORT_MODAL_CONTENT: 'Доступен запрос отчёта по всем рекламным кампаниям за последние 90 дней.',
  LABEL: 'Выберите даты',
  HINT: 'Отчёт будет сформирован и отправлен на электронную почту. Также отчет будет доступен в разделе «Отчеты»',
  REQUEST: 'Запросить',
  CLOSE: 'Закрыть',
  REQUEST_REPORT_SUCCESS_NOTIFICATION:
    'Отчет по рекламе будет сформирован в течение нескольких минут и отправлен на электронную почту. Также отчет будет доступен в разделе «Отчеты»',
  REQUEST_REPORT_EXISTS_NOTIFICATION:
    'Отчет по рекламе за указанный период был сформирован ранее и отправлен на электронную почту. Пожалуйста, проверьте свою электронную почту',
  REQUEST_REPORT_ERROR_NO_ADS_NOTIFICATION:
    'Для формирования отчёта недостаточно информации. Реклама или видео не найдены',
  WRONG_RANGE_START_MORE_END_ERROR: 'Дата начала не может быть позже даты окончания',
  WRONG_RANGE_MORE_MAX_ERROR: (maxDays: number) => `Максимальный период для выгрузки отчёта - ${maxDays} дней`,
  WRONG_RANGE_LESS_MIN_OR_MORE_MAX_ERROR: (maxDays: number) =>
    `Даты должны находиться в диапазоне последних ${maxDays} дней`,
};
